import * as React from "react";
import { ICheckAccessProps, IPermissionContextModel } from "Models/PermissionContextModel";

export const permissionContextUnloaded: IPermissionContextModel = {
    token: "",
    isAuth: undefined,
    loading: true,
    loaded: undefined,
    setToken: (_: string) => {
        return;
    },
    logOut: () => {
        return;
    },
    GetClaimValue: (_: string): any => {
        return '';
    },
    HasClaim: (_: string): boolean => {
        return false;
    },
    HasAccess: (_: string): boolean => {
        return false;
    },
    HasAnyAccess: (_: string[]): boolean => {
        return false;
    },
    HasAllAccess: (_: string[]): boolean => {
        return false;
    },
    HasRole: (_: string): boolean => {
        return false;
    },
    HasAnyRole: (_: string[]): boolean => {
        return false;
    },
    CheckAccessIf: (accsess: any): boolean => {
        return false;
    },
    CheckAccess: (props: ICheckAccessProps): any => {
        return props.children;
    }
};

const PermissionContext = React.createContext<IPermissionContextModel>(permissionContextUnloaded);

export default PermissionContext;
